import bestRouteMatch from 'rlink-router/bestRouteMatch';
import fillRoutePattern from 'rlink-router/fillRoutePattern';
import { HASH } from 'rlink-router/constants';

export default function pathForRouteInfo (
    {routesByView, defaultLocale, defaultRegion},
    view,
    {region = null, locale = null, [HASH]: hash = '', ...params} = {}) {
  if (view.startsWith('/')) {
    // probably already a path (and certainly not a valid view name)
    return view;
  }
  // Try for "perfect" match first:
  if (!(view in routesByView)) {
    throw new Error(`Unknown view name: ${view}`);
  }
  let numParamKeys = Object.keys(params).length;
  let bestRoute;
  if (numParamKeys in routesByView[view]) {
    bestRoute = bestRouteMatch(params, routesByView[view][numParamKeys], 0);
  }
  if (!bestRoute) {
    bestRoute = bestRouteMatch(params, [].concat(...Object.values(routesByView[view])));
  }

  if (!bestRoute) {
    throw new Error(`Cannot find route for: ${JSON.stringify({view, params})}`);
  }

  let paramsExcludingHardCodedValues = {};
  for (let name in params) {
    if (!(name in bestRoute.singleValueParams
        && bestRoute.singleValueParams[name] === params[name])) {
      paramsExcludingHardCodedValues[name] = params[name];
    }
  }

  let isDefaultRegion = !region || region === defaultRegion;
  let isDefaultLocale = !locale || locale === defaultLocale;

  if (isDefaultRegion && isDefaultLocale) {
    return fillRoutePattern(bestRoute.routePattern, paramsExcludingHardCodedValues) + hash;
  }

  if (isDefaultLocale && !isDefaultRegion) {
    return `/${region}${fillRoutePattern(bestRoute.routePattern, paramsExcludingHardCodedValues)}${hash}`;
  }
  return `/${region}/${locale}${fillRoutePattern(bestRoute.routePattern, paramsExcludingHardCodedValues)}${hash}`;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/pathForRouteInfo.js